export default "66dc186dcf845285.svg"